<template>
  <div>
    <PageHeader
      :title="title"
      :subtitle="subtitle"
      :no-padding="true"
      :icon="icon"
      :loading="isLoading"
    />
    <v-tabs dark grow centered slider-color="info">
      <v-tab
        v-for="(item, index) in navItems"
        :key="`navItem-${index}`"
        :id="item.page.name"
        @click="setCurrent(item.page)"
        active-class=""
      >
        <v-icon class="mr-1">{{ item.page.icon }}</v-icon
        >{{ item.name }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: Object,
    pages: {
      type: Object,
      required: true,
    },
    navItems: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
  },
  data: () => ({
    title: 'Manage Equipment',
    subtitle:
      'Manage equipment and track history. View current equipment status and history.',
    icon: 'construction',
  }),
  computed: {
    _currentPage: {
      get() {
        return this.currentPage
      },
      set(val) {
        this.$emit('update:currentPage', val)
      },
    },
  },
  watch: {
    currentPage(val) {
      if (this.$route && this.baseRouteName) {
        let newRoute = `${this.$route.path}/${val.subpath}`
        window.history.pushState({}, '', newRoute)
      }
    },
  },
  methods: {
    isCurrent(name) {
      return this._currentPage && this._currentPage.name == name
    },
    setCurrent(page) {
      this._currentPage = page
    },
  },
}
</script>
